export default "__VITE_ASSET__c32fc898__"